// extracted by mini-css-extract-plugin
export default {"commonContentLayout":"CommonContentLayout_commonContentLayout__pyboE"};